export const BACK_BAR_TEXT = {
  nav: '상위 화면',
  back: '상위 화면으로',
} as const;
